export const getUserId = (path: string) => {
  // 最初に含まれる空文字を削除
  const _path = path.substr(1);
  //   URLをスラッシュ毎に区切った配列を作成
  const pathParams = _path.split('/');
  //   userIdを返す
  return pathParams[2];
};
